import type { GetAdsActivityConfigResponseAction } from './getAdsActivityConfig.action';
import type { GetRoleResponseAction } from './getRole.action';
import type { GetUserDataResponseAction } from './getUser.action';
import type { SetUserViewResponseAction } from './setUserView.action';
import type { UpdateAdsActivityConfigResponseAction } from './updateAdsActivityConfig.action';
import type { UpdateUserResponseAction } from './updateUser.action';
import type { UpdateUserSettingsRequestAction, UpdateUserSettingsResponseAction } from './updateUserSettings.action';

export * from './getRole.action';
export * from './getUser.action';
export * from './setUserView.action';
export * from './updateUser.action';
export * from './updateUserSettings.action';
export * from './getAdsActivityConfig.action';
export * from './updateAdsActivityConfig.action';

export type UserAction =
  | GetRoleResponseAction
  | GetUserDataResponseAction
  | SetUserViewResponseAction
  | UpdateUserResponseAction
  | UpdateUserSettingsRequestAction
  | UpdateUserSettingsResponseAction
  | GetAdsActivityConfigResponseAction
  | UpdateAdsActivityConfigResponseAction;
